export const BASE_URL = 'http://ctd-api.cloud.toast.com';
export const TOKEN_ERROR_CODE = -20001;
